exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".k_L1YqAaOVldL6QyNPDeC {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  align-content: stretch;\n  height: 100%;\n}\n.k_L1YqAaOVldL6QyNPDeC ._12yirJnAwZEyuaGXAL4IiZ {\n  flex: 1;\n  overflow: hidden;\n}\n", ""]);
// Exports
exports.locals = {
	"snapshot-compare": "k_L1YqAaOVldL6QyNPDeC",
	"chart-container": "_12yirJnAwZEyuaGXAL4IiZ"
};